import React, { useState, useEffect } from "react";
import { EmailBlock } from "./styled";
import { QuestionBlock } from "../Question/styled";
import { Container, Heading, Text } from "../../styled";
import ProgressBar from "../ProgreesBar/ProgressBar";
import Button from "../design_components/Button/Button";
import Input from "../design_components/Input/Input";
import clearIcon from "./../../resources/images/icons/clear_icon.svg";
import { emailRegExp } from "../../constants/regexp";
import { useHistory } from "react-router";
import { createEventObjectFunction } from "../../utils/helper";
import { analytics } from "../../firebaseAnalytics";
import {
  onboardingCompleteEventAmplitude,
  onboardingFillEventAmplitude,
} from "../../amplitude/events";
import {
  onboardingCompleteEvent,
  onboardingFillEvent,
} from "../../firebaseAnalytics/events";
import ReactPixel from "react-facebook-pixel";
import { CardInputWrapper } from "../Subscription/styled";
import { PRIVACY_LINK, TERMS_LINK } from "../../constants/data";

const Email = ({
  data,
  type,
  route,
  setUserEmail,
  pixelObject,
  setPixelObject,
  remoteConfig,
  landingId,
}) => {
  const [email, setEmail] = useState("");
  const [isEmailValid, setEmailValid] = useState(null);

  const history = useHistory();

  const clearEmailFunction = () => {
    setEmail("");
  };

  const validateEmail = (email) => {
    const isVal = String(email).toLowerCase().match(emailRegExp);
    if (email.length === 0) {
      setEmailValid(null);
      return;
    }
    setEmailValid(!!isVal);
  };

  const handleButtonClick = () => {
    const eventObj = createEventObjectFunction(null, null, landingId);
    eventObj.email = email;
    // Событие №5 onboarding_complete
    onboardingCompleteEvent(analytics, eventObj);
    onboardingCompleteEventAmplitude(eventObj);
    setUserEmail(email);
    let dataObj = { ...pixelObject, em: email };
    setPixelObject(dataObj);
    ReactPixel.trackCustom("Complete registration", dataObj);
    // если remoteConfig пэйвол 0, то редирект на текущий, если 1, 2 или 3, то на страницу paywall
    if (remoteConfig.paywallId === 0) {
      history.push(data.nextRoute[0]);
    } else {
      // если включен платный триал, то переходим на страницу с выбором цены
      if (remoteConfig.paidTrialEnabled) {
        history.push(data.nextRoute[2]);
      } else {
        // если нет, то сразу попадаем на пейвол (новый от 19.05)
        history.push(data.nextRoute[2]);
      }
    }
  };

  useEffect(() => {
    const eventObj = createEventObjectFunction(
      data.eventFillName,
      null,
      landingId
    );
    // Событие №4 fill
    onboardingFillEvent(analytics, eventObj);
    onboardingFillEventAmplitude(eventObj);
    return () => window.scrollTo(0, document.body);
  }, []);

  useEffect(() => {
    validateEmail(email);
  }, [email]);

  return (
    <QuestionBlock>
      <Container.Content>
        <QuestionBlock.Wrapper>
          <QuestionBlock.Top>
            <ProgressBar
              currentBlock={data.questionBlock}
              currentQuestion={data.questionNum}
              totalQuestion={data.totalQuestion}
              specialProgressText={data.specialProgressText}
            />
            <EmailBlock.Title>
              <Heading.Fourth style={{ fontSize: 22, lineHeight: "28px" }}>
                {remoteConfig.createContent
                  ? remoteConfig.createContent.title
                  : null}
              </Heading.Fourth>
            </EmailBlock.Title>
            <EmailBlock.Text>
              <Text.Fourth>
                {remoteConfig.createContent
                  ? remoteConfig.createContent.text.map((text) => {
                      return (
                        <span style={{ fontWeight: text.bold ? 700 : 400 }}>
                          {text.content}
                        </span>
                      );
                    })
                  : null}
              </Text.Fourth>
            </EmailBlock.Text>
            <EmailBlock.Input>
              <Input
                placeholder={"Email"}
                icon={clearIcon}
                value={email}
                setValueFunction={setEmail}
                clickIconFunction={clearEmailFunction}
                isValid={!!isEmailValid}
                type={"email"}
              />
              {email.length === 0 ? (
                ""
              ) : !isEmailValid ? (
                <CardInputWrapper.Message>
                  Please enter a valid email
                </CardInputWrapper.Message>
              ) : null}
            </EmailBlock.Input>
          </QuestionBlock.Top>
          <EmailBlock.Bottom>
            <EmailBlock.Button style={{ marginBottom: 35 }}>
              <Button
                type={"default"}
                isGradient={true}
                text={"Get My Sleep Plan"}
                disabled={!isEmailValid}
                action={handleButtonClick}
              />
            </EmailBlock.Button>
            <EmailBlock.Terms>
              <Text.Fifth style={{ lineHeight: "20px" }}>
                <span>
                  By continuing, you agree to Journey’s<br></br>
                </span>
                <a href={TERMS_LINK}>Terms </a>
                <span> and </span>
                <a href={PRIVACY_LINK}> Privacy Policy</a>
              </Text.Fifth>
            </EmailBlock.Terms>
          </EmailBlock.Bottom>
        </QuestionBlock.Wrapper>
      </Container.Content>
    </QuestionBlock>
  );
};

export default Email;
